/**
 * the html number input treats a dot as its decimal separator. This is problematic for cases where users copy/paste a value containing a dot from another application
 * we might need to interpret that dot as the thousand separator
 * This helper handles various formats:
 * - "2008.23" → 2008.23 (dot as decimal, 1 or 2 digits after)
 * - "7.141" → 7141 (dot as thousand separator, 3+ digits after)
 * - "7.141,55" → 7141.55 (dot as thousand, comma as decimal)
 * - "1,234.56" → 1234.56 (comma as thousand, dot as decimal)
 * - "2008,23" → 2008.23 (comma as decimal)
 */
export const parsePastedNumericValue = pastedValue => {
  if (!pastedValue) return null;

  // Remove any non-numeric characters except digits, comma, dot, and minus
  let value = pastedValue.replace(/[^\d,.-]/g, '');

  const hasComma = value.includes(',');
  const hasDot = value.includes('.');

  if (hasComma && hasDot) {
    // Both present: last one is decimal separator
    const lastComma = value.lastIndexOf(',');
    const lastDot = value.lastIndexOf('.');
    value =
      lastComma > lastDot
        ? value.replace(/\./g, '').replace(',', '.') // 7.141,55 → 7141.55
        : value.replace(/,/g, ''); // 1,234.56 → 1234.56
  } else if (hasDot) {
    // Only dot: check if it has 2 digits after it
    const parts = value.split('.');
    if (parts.length === 2 && parts[1].length <= 2) {
      // 1-2 digits after dot: decimal (2008.23 → 2008.23)
      value = value;
    } else {
      // 3+ digits or multiple dots: thousand separator (7.141 → 7141)
      value = value.replace(/\./g, '');
    }
  } else if (hasComma) {
    // Only comma: decimal separator (2008,23 → 2008.23)
    value = value.replace(',', '.');
  }

  const numericValue = parseFloat(value);
  return isNaN(numericValue) ? null : numericValue;
};
